import React from "react";
import { useState } from "react";
import PopModal from "../../../Constant/Custom/Models/PopModal";
import { serverUrl } from "../../../Constant/Static/config";
import axios from "axios";

const DueStudents = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [showCancelButton, setShowCancelButton] = useState(false);
    const [onCancel, setOnCancel] = useState(() => () => { });
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [data, setData] = useState({ appno: "" });

    const handleChange = (e) => {
        // // console.log("appno",e.value);
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const resetData = () => {
        setData({ appno: "" });
    };

    const handleInsert = async () => {
        // // console.log("appno",appno);

        try {
            if (!data.appno) {
                setModalType({
                    title: "Invalid",
                    icon: "error",
                    text: "Enter the application number",
                });
                setShowCancelButton(false);
                // setOnCancel(() => closeModal);
                setOnConfirm(() => closeModal);
                openModal();
                return;
            }
            const response = await axios.post(
                `${serverUrl}/api/admin/cv/insert-due-student`,
                {
                    appNo: data.appno
                }
            );

            if (response.status === 200) {
                setModalType({
                    title: "Success",
                    icon: "success",
                    text: "Student Inserted to due list successfully",
                });
                setShowCancelButton(false);
                // setOnCancel(() => closeModal);
                setOnConfirm(() => closeModal);
                openModal();
                resetData();
            }
        } catch (err) {
            setModalType({
                title: "Invalid",
                icon: "error",
                text: err.response.data.message,
            });
            setShowCancelButton(false);
            setOnConfirm(() => closeModal);
            openModal();
            // console.log("error", err);
        }
    };

    const handleConfirmation = () => {
        if ( !data.appno) {
            setModalType({
                title: "Invalid",
                icon: "error",
                text: "Fill All the neccessary fields",
            });
            setShowCancelButton(false);
            // setOnCancel(() => closeModal);
            setOnConfirm(() => closeModal);
            openModal();
            return;
        }
        const message = `Do you want to insert the student to ` + data.appno+` due list`;
        // console.log(message);

        setModalType({
            title: "Confirmation",
            icon: "info",
            text: message,
        });
        setShowCancelButton(true);
        setOnCancel(() => closeModal);
        setOnConfirm(() => handleInsert);
        openModal();
    };

    return (
        <div>
            <h1 style={{ textAlign: "center" }} className="title">Insert Studetns from SC,ST,SCA To OC,BC,BCM,MBC</h1>
            <div style={{ display: 'flex', justifyContent: 'center', marginLeft: '50px' }}>
                <div className="input-group">
                    <input
                        className="input-field"
                        style={{ width: "80%" }}
                        type="text"
                        name="appno"
                        value={data.appno}
                        onChange={handleChange}
                        placeholder="Enter Application Number"
                    />
                </div>
                <div className="ProceedButton" style={{ marginRight: '80px' }}>
                    <button onClick={handleConfirmation}>Insert Student</button>
                </div>

            </div>
            <div
                style={{
                    position: "relative",
                    alignSelf: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <PopModal
                    isOpen={isModalOpen}
                    type={modalType}
                    confirmButtonText="OK"
                    showCancelButton={showCancelButton}
                    cancelButtonText="Cancel"
                    onConfirm={onConfirm}
                    onCancel={onCancel}
                />
            </div>
        </div>
    );
};

export default DueStudents;
